module.exports = __webpack_public_path__ + "img/icon.0c1b7562.png";